import { AxiosInstance } from 'axios';

const langInterceptor = (api: AxiosInstance): void => {
  api.interceptors.request.use(
    (config) => {
      const lang: string = localStorage.getItem('lang') || 'pl';

      config.headers.common.Lang = `${lang}`;

      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default langInterceptor;
